<template>
  <div class="ErrorPage">
    <div class="ErrorPage-MainImage">
      <img src="../../assets/img/500.png" width="300" />
    </div>

    <p class="text-xl text-bold">
      Internal server error.
    </p>

    <div class="ErrorPage-Links">
      <div class="link hoverble" @click="onClickBack">
        {{ $t('Go back') }}
      </div>

      <div class="link hoverble" @click="onClickLogout">
        {{ $t('Logout') }}
      </div>

      <div class="link hoverble" @click="onClickDocLink">
        {{ $t('error_pages.contact_support') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const messages = {
  en: {
    'Contact Support': 'Contact Support',
    'Go back': 'Go home',
    Logout: 'Logout',
  },
  ja: {
    'Contact Support': 'お問い合わせページ',
    'Go back': '戻る',
    Logout: 'ログアウト',
  },
};

export default {
  name: 'Error-500',
  i18n: { messages },
  methods: {
    ...mapActions('auth', ['logout']),

    onClickBack() {
      this.$router.go(-1);
    },

    onClickLogout() {
      this.logout();
    },

    onClickDocLink() {
      window.open('https://pages.mobingi.com/form-general-jp', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.ErrorPage {
  height: 100vh;
  background-color: #f1f1f1;
  text-align: center;

  &-MainImage {
    padding: $space-md 0;
  }

  &-Links {
    display: flex;
    justify-content: center;

    & > div {
      margin: 0 $space-sm;
    }
  }
}
</style>
